// 台湾（繁中）配置
export default {
  title: 'MLB 制勝時刻',
  pageMainId: '3', // 语言对应的parentId
  iconTextShow: '立即下載轟出你的制勝一擊！',
  bannerId: '9',
  downLinkArea: {
    apple: 'https://app.adjust.com/1crn00p3?campaign=iOSbutton',
    google: 'https://app.adjust.com/1cylwz8b?campaign=button_GP'
  },
  menu: [ // 菜单项配置
    {id: 'home',label: '首頁'},
    {id: 'news',label: '最新消息'},
    {id: 'feature',label: '遊戲特色'},
    {id: 'activity',label: '活動情報'},
  ],
  page2: {
    title: '最新消息',
    tabs: [
      {id: 'all',label: '一覽'},
      {id: 'maintain',label: '維護資訊'},
      {id: 'announcement',label: '遊戲公告'},
      {id: 'activity',label: '活動情報'},
    ],
    tabLib: {
      all: '41',
      maintain: '42',
      announcement: '43',
      activity: '44'
    },
    tabLibColor: {
      42: '#268044',
      43: '#b30000',
      44: '#409EFF'
    },
    tabTagLib: {
      42: '維護資訊',
      43: '遊戲公告',
      44: '活動情報'
    }
  },
  page3: [
    {id:'1',title: "真人共鬥，暢快對決",content: '與世界各地玩家的頂尖對決，⽤⼼打造你的全明星陣容，制霸全球！',},
    {id:'2',title: "強投豪打，制勝一擊",content: '最緊張刺激的投打對決，⼀球定江⼭，你就是英雄！'},
    {id:'3',title: "多元玩法，完全制霸",content: '完成多種挑戰任務及訓練，不斷升級你的投打技能！'},
  ],
  page4: {
    title: '活動情報',
    getCardId: 13 // 拉取card时传的id
  },
  pageBottom: {
    logo: '', // 底部展示的logo
    ruleList: [
      {id: '1',label: '用戶協議',url:'https://www.wildcaly.com/ToSTw.html'},
      {id: '2',label: '隱私權政策',url:'https://www.wildcaly.com/privacypolicyTw.html'},
    ],
    iconAndLink: [ // 图片和跳转
      {id: 'faceBook',imgName: 'faceBook',url: ''},
      {id: 'twitter',imgName: 'twitter',url: ''},
      {id: 'youtube',imgName: 'youtube',url: ''},
      {id: 'email',imgName: 'email',url: ''},
    ]
  },
}
